var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 21.0139L8.09407 14.3764L8.01648 14.2057L7.84579 14.1281L1.2083 11.1111L7.84579 8.09407L8.01648 8.01648L8.09407 7.84579L11.1111 1.2083L14.1282 7.84579L14.2057 8.01648L14.3764 8.09407L21.0139 11.1111L14.3764 14.1281L14.2057 14.2057L14.1282 14.3764L11.1111 21.0139ZM22.2222 23.7917L20.9413 20.9737L20.8637 20.803L20.693 20.7254L17.875 19.4444L20.693 18.1635L20.8637 18.0859L20.9413 17.9152L22.2222 15.0972L23.5032 17.9152L23.5807 18.0859L23.7514 18.1635L26.5695 19.4444L23.7514 20.7254L23.5807 20.803L23.5032 20.9737L22.2222 23.7917Z",
    stroke: "#98A292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AIIcon.9d15d7bf593d8be6b1cf88b973902b89.svg";
export { ForwardRef as ReactComponent };